import { Radio, RadioGroupProps, Stack } from "@mantine/core";
import _ from "lodash";

import { useIsLoadingSearchData, useSearchRouteInfo } from "../hooks/routing";

const OPTIONS = [
  {
    value: "3",
    label: "0 - 3 Months",
  },
  {
    value: "6",
    label: "0 - 6 Months",
  },
  {
    value: "9",
    label: "0 - 9 Months",
  },
  {
    value: "12",
    label: "0 - 12 Months",
  },
  {
    value: "18",
    label: "0 - 18 Months",
  },
];

export function ActiveWithinSelector(props: Omit<RadioGroupProps, "children">): JSX.Element {
  const { query, replaceQuery } = useSearchRouteInfo();
  const loading = useIsLoadingSearchData();

  return (
    <Radio.Group
      value={query.activeWithin ?? "12"}
      onChange={(v) => {
        replaceQuery({
          activeWithin: v,
        });
      }}
      withAsterisk
      {...props}
    >
      <Stack>
        {_.map(OPTIONS, (option) => (
          <Radio
            disabled={loading}
            size="xs"
            key={option.value}
            value={option.value}
            label={option.label}
            styles={{
              label: {
                fontSize: 14,
              },
            }}
          />
        ))}
      </Stack>
    </Radio.Group>
  );
}
